<template>
    <header class="bg-black-transparent fixed-top" id="main-header">
        <div class="container">
            <nav class="navbar navbar-light  pl-0 pr-0">
                    <router-link class="navbar-brand logo" :to="{ name: 'home' }"></router-link>
                    <div class="custom-new-menu">
                    <ul class="navbar-nav mr-3 custom-navbar shopping-navbar">
                        <li class="nav-item">
                            <div class="dropdown">
                                <!-- <a
                                    class="dropdown-toggle"
                                    href="#"
                                    data-toggle="dropdown" 
                                    aria-haspopup="true" 
                                    aria-expanded="false">
                                    {{ $t('Campaigns') }}
                                </a> -->

                                <div class="dropdown-menu dropdown-menu-right">
                                    <template v-for="(data, index) in cmsPages">
                                        <router-link v-if="data.type=='Campaign'" :to="{ name: 'cmspage', params: {pagepath: data.url_path } }" :key="index">{{ data.title }}</router-link>
                                    </template>
                                    <!-- <router-link :to="{ name: 'cmspage', params: {pagepath: 'nexen-tyre-puncture-warranty' } }">{{ $t('Nexen Puncture Warranty') }}</router-link>
                                    <router-link :to="{ name: 'cmspage', params: {pagepath: 'falken-tyres-giftcard-campaigns' } }">{{ $t('Falken Giftcard Campaigns') }}</router-link>
                                    <router-link :to="{ name: 'cmspage', params: {pagepath: 'falken-tyres-5-year-guarantee' } }">{{ $t('Falken 5 Year Guarantee') }}</router-link> -->
                                </div>
                            </div>
                        </li>

                        <li class="nav-item" v-if="is_show_in_campaign">
                                <router-link
                                    v-if="!loggedIn" 
                                    :to="{ name: 'login' }">
                                    <span> {{ $t('Login') }} </span>
                                </router-link>
                        </li>

                        <li class="nav-item" v-if="loggedIn && is_show_in_campaign">

                            <router-link
                                v-if="loggedIn" 
                                :to="{ name: 'profile' }">
                                <span v-if="userDetails"> {{ $t('Welcome') }} {{userDetails.first_name}}  </span>
                            </router-link>

                        </li>

                        <li class="nav-item add-cart mr-2" v-if="is_show_in_campaign">
                            <quick-cart/>
                        </li>
                        
                        <li class="nav-item" v-if="is_show_in_campaign">
                            <div class="dropdown">
                                <button 
                                    type="button" 
                                    class="btn btn-outline-light dropdown-toggle" 
                                    data-toggle="dropdown" 
                                    aria-haspopup="true" 
                                    aria-expanded="false">
                                    {{ selectedLanguage.label }}
                                </button>

                                <div class="dropdown-menu dropdown-menu-right">
                                    <a v-for="(lang, index) in languages" @click="setLanguage(lang.value, lang.label)" :key="index"> {{lang.label}}</a>
                                </div>
                            </div>
                        </li>

                    </ul>
                    <!-- <button class="navbar-toggler header-nav-toggler" 
                        @click="showPopup = !showPopup" 
                        ref="button" 
                        type="button" 
                        data-toggle="collapse" 
                        data-target="#navbarToggler" 
                        aria-controls="navbarToggler" 
                        aria-expanded="false" 
                        aria-label="Toggle navigation">
                        <span class="navbar-toggler-icon"></span>
                    </button> -->
                </div>

                <!-- :class="{show: showPopup}" -->
                <!-- <div 
                    class="collapse navbar-collapse" 
                    id="navbarToggler" 
                    v-closable="{
                    exclude: ['button'],
                    handler: 'onClose'
                    }"
                    > -->
                <div class="collapse navbar-collapse" :class="{show: showPopup}">
                    <ul class="navbar-nav ml-auto mt-2 mt-lg-0 custom-navbar">
                        <!-- <li class="nav-item"><router-link :to="{ name: 'products' }">Products</router-link></li> -->
                        <!-- <li class="nav-item"><a href="#">Brands</a></li>
                        <li class="nav-item"><router-link :to="{ name: 'product-details' }">Tyre Info</router-link></li>
                        <li class="nav-item"><a href="#">Instructions</a></li>
                        
                        <li class="nav-item"><a href="#">Contact</a></li> -->

                        <li class="nav-item">
                            <template v-for="(data, index) in cmsPages">
                                <router-link v-if="data.type=='Hamburger'" :to="{ name: 'cmspage', params: {pagepath: data.url_path } }" :key="index">{{ data.title }}</router-link>
                            </template>
                        </li>
                        <!-- <li class="nav-item"><router-link :to="{ name: 'cmspage', params: {pagepath: 'about-us' } }">{{ $t('About Us') }}</router-link></li>
                        <li class="nav-item"><router-link :to="{ name: 'cmspage', params: {pagepath: 'tyre-size-info' } }">{{ $t('Tyre info') }}</router-link></li>
                        <li class="nav-item"><router-link :to="{ name: 'cmspage', params: {pagepath: 'how-to-select-tyres' } }">{{ $t('How to select tyres') }}</router-link></li>
                        <li class="nav-item"><router-link :to="{ name: 'cmspage', params: {pagepath: 'contact-us' } }">{{ $t('Contact us') }}</router-link></li> -->

                        <!-- <li class="nav-item" v-if="loggedIn">

                            <router-link
                                v-if="loggedIn" 
                                :to="{ name: 'profile' }">
                                <span> Welcome {{userDetails.first_name}}  </span>
                            </router-link>
                        </li> -->
                    </ul>
                </div>
            </nav>
        </div>
        
    </header>
    
</template>
<script src="https://apis.google.com/js/api.js" type="text/javascript"></script>
<script src="https://ajax.googleapis.com/ajax/libs/jquery/3.4.1/jquery.min.js"></script>
<script src="https://maps.googleapis.com/maps/api/js?key=AIzaSyA7IkglpRYrOiH_2__bS6dC9xz672zbNLY&libraries=places"></script>

    
<script>
import { mapGetters, mapActions } from "vuex";
import QuickCart from "../QuickCart";
import Vue from 'vue';

let handleOutsideClick
Vue.directive('closable', {
  bind (el, binding, vnode) {
    handleOutsideClick = (e) => {
      e.stopPropagation()
      const { handler, exclude } = binding.value
      let clickedOnExcludedEl = false
      exclude.forEach(refName => {
        if (!clickedOnExcludedEl) {
          const excludedEl = vnode.context.$refs[refName]
          clickedOnExcludedEl = excludedEl.contains(e.target)
        }
      })
      if (!el.contains(e.target) && !clickedOnExcludedEl) {
        vnode.context[handler]()
      }
    }
    document.addEventListener('click', handleOutsideClick)
    document.addEventListener('touchstart', handleOutsideClick)
  },

  unbind () {
    document.removeEventListener('click', handleOutsideClick)
    document.removeEventListener('touchstart', handleOutsideClick)
  }
})


export default{
  name: "Header",
  data() {
    return {
        languageDropdown: true,
        selectedLanguage: {
          value: ('locale' in localStorage ? localStorage.getItem('locale') : process.env.VUE_APP_I18N_LOCALE),
          label: ('locale_label' in localStorage ? localStorage.getItem('locale_label') : process.env.VUE_APP_I18N_LANGUAGE_LABEL)
        },
        itemsCount: 0,
        partsCount: 0,
        subTotalPrice: 0,
        loader: false,
        isLoggedinAsCustomer: false,
        currentUserPermissions: [],
        app_type: process.env.VUE_APP_TYPE,
        state: false,
        showPopup : false,
        menuDropdown: false
    }
  },
  components:{
      "quick-cart": QuickCart
  },
  async created() {
    this.getCmsPageList(['Hamburger', 'Campaign'])
  },
  computed: {
        ...mapGetters('auth', [
            'userDetails',
            'loggedIn',
            'authenticating',
            'authenticationError',
            'authenticationErrorCode',
            'authenticationSuccess',
            'virtualUserDetails',
            'userPermission'
        ]),
        ...mapGetters("cmspage", ["cmsPages", "loading", 'isShow']),
        ...mapGetters('app', ['currentLang']),
        ...mapGetters("HeaderFooterControl", ["is_show_in_campaign"]),
       // ...mapGetters('cart', ['cartData', 'priceDetail']),
  },
    watch: {
        loggedIn: {
            immediate: true,
            deep: true,
            handler(newVal, oldVal) {
                // this.cartDetails();
            }
        },
        // cartData: function (val) {
        //     this.itemsCount = val.length
        //     var count = 0;
        //     val.filter(function(n) {
        //         count = count + parseInt(n.TotalPiece)
        //     });

        //     this.partsCount = count
        // },
        virtualUserDetails:{
            immediate: true,
            handler(newVal){
                this.isLoggedinAsCustomer = !!newVal;
            }
        },
        '$route':{
            immediate: true,
            handler(newVal){

                if(newVal.name == "home") {
                    $('body').addClass('home');
                } else {
                    $('body').removeClass('home');
                }

                if(this.showPopup) {
                    this.showPopup = false;
                }

                this.setIsLoggedIn();
                this.getVirtualUserDetails();
            }
        },
        userDetails: {
            immediate: true,
            handler(newVal, oldVal) {
                if(newVal){
                }
            }
        },
        currentLang: {
            handler(newVal) {
                this.getCmsPageList(['Hamburger', 'Campaign'])
            }
        }
    },
    methods: {
        ...mapActions('auth', [
            'logout',
            'memberLogout',
            'getVirtualUserDetails',
            'setIsLoggedIn'
        ]),
        ...mapActions('app', [
            'setLang',
            'setCurrentLogoutTime'
        ],
        'cart', ['clearCartProducts']),
        ...mapActions("cmspage", ["getCmsPages"]),
        // ...mapActions('cart', ['fetchCartData', 'updatePrice']),
        loginPopupState(event) {
        },
        getCmsPageList(pageType) {
            this.getCmsPages({pageType: pageType, lang: (this.currentLang == "fi_FI" ? 2 : 1)});
        },
        userLogout() {
            // this.setCurrentLogoutTime();
            localStorage.removeItem('userDetails');
            // let priceDetail = {
            //     'grossPrice': 0,
            //     'vat': 0,
            //     'grandTotal': 0
            // };
            // this.updatePrice(priceDetail);
            this.clearCartProducts()
            this.logout()
            this.$router.push({ 
                path: '/login', params: {  }, replace: true
            }).catch(err => {});
        },
        onLogoutAsCustomer() {
            this.memberLogout();
        },
        setLanguage(value, lable){

            this.$i18n.locale = value
            localStorage.setItem('locale', value);
            localStorage.setItem('locale_label', lable);
            this.setLang(value)
            this.selectedLanguage.value = value
            this.selectedLanguage.label = lable
            this.languageDropdown = !this.languageDropdown
        },
        setNewLanguage(value){

            this.$i18n.locale = value
            this.setLang(value)
            this.languageDropdown = !this.languageDropdown
            
        },
        // cartDetails() {
        //     if (this.loggedIn) {
        //         this.loader = true;
                
        //         this.fetchCartData(this.currentLang)
        //         .then(() => {
        //         })
        //         .finally(() => {
        //             this.loader = false;
        //         })
        //     } else {
        //         this.itemsCount = 0
        //         this.partsCount = 0
        //         this.netPrice = 0
        //     }
        // },
        openLangDropdown() {
            this.languageDropdown = true;
        },
        closeLangDropdown() {
            this.languageDropdown = false;
        },

        openMenuDropdown() {
            this.showPopup = true;
        },
        closeMenuDropdown() {
            this.showPopup = false;
        },

        // changeLang() {

        // },
        onClose () {

            if(this.showPopup == true) {
                this.showPopup = false
            } else {
                this.showPopup = true
            }
        }
    }
};
</script>